import { useParams } from "react-router-dom"
import { useHub, useScreen } from "../../../core/Global"
import { useEffect, useState } from "react";
import JobInvoice from "../../crm/jobs/models/JobInvoice";
import Indicator from "../../../components/base/Indicator";
import Icon from "../../../components/base/Icon";
import FlexRow from "../../../components/base/FlexRow";
import IconButton from "../../../components/base/IconButton";



export default function InvoiceTapToPay() {

    const moneyFormatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    });

    const { owner, id, token } = useParams()
    const hub = useHub()
    const screen = useScreen()
    const [model, modelSet] = useState<JobInvoice>()
    const [loading, loadingSet] = useState<boolean>(true)
    const [expired, expiredSet] = useState<boolean>(true)


    useEffect(() => {
        hub.Get(`/base/public/share/invoice/${owner}/${id}/${token}`, res => {
            if (res.success) {
                modelSet(res.data)
                expiredSet(false)
            }
            else expiredSet(true)
            loadingSet(false)
        })
    }, [])


    return (
        <>
            {
                loading ?
                    <FlexRow column className="bg-white" style={{
                        height: screen.height,
                        paddingTop: 150,
                        paddingBottom: 100
                    }}>
                        <Icon icon="spinner-third" type="thin" spin size={60} />
                    </FlexRow>
                    :
                    model ?
                        <FlexRow column className="bg-white"
                            style={{
                                height: screen.height,
                                paddingTop: 150,
                                paddingBottom: 100
                            }}>

                            <img src="/assets/taptopay/taptopay.png" style={{
                                width: screen.width / 3
                            }} />

                            <div className="mt-10 fs-3 fw-bold">
                                Tap Card to Pay the Invoice
                            </div>

                            <FlexRow column className="mt-auto">
                                <IconButton icon="times" className="bg-gray-300 mb-10"
                                    href="rinvox://taptopaydiscard" />

                                <h1 className="mb-5" style={{
                                    fontSize: 46,
                                    fontWeight: 200,
                                }}>
                                    {moneyFormatter.format(model?.total ?? 0)}
                                </h1>

                                <FlexRow>
                                    <img src="/assets/taptopay/visa.svg" className="me-3" style={{ height: 15 }} />
                                    <img src="/assets/taptopay/master.svg" className="me-3" style={{ height: 18 }} />
                                    <img src="/assets/taptopay/amex.png" style={{ height: 22 }} />
                                </FlexRow>

                            </FlexRow>

                        </FlexRow>
                        : <></>
            }
        </>
    )
}